module.exports = __webpack_public_path__ + "static/media/workingmemory-words-8.352061b1.mp3";